import {
  GET_RESULT_SUBMIT,
  GET_RESULT_SUBMIT_SUCCESS,
  GET_RESULT_SUBMIT_FAIL,
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  GET_SERELOGY_RESULT,
  GET_SERELOGY_RESULT_SUCCESS,
  GET_SERELOGY_RESULT_FAIL,
  GET_MICRO_REPORT,
  GET_REPORT_MICRO_SUCCESS,
  GET_REPORT_MICRO_FAIL,
  GET_QUALITATIVE_SUMMARY,
  GET_QUALITATIVE_SUMMARY_SUCCESS,
  GET_QUALITATIVE_SUMMARY_FAIL,
} from "./actionTypes";

////////////////////////////////
export const getResultSubmit = (id) => ({
  type: GET_RESULT_SUBMIT,
  payload: id,
});

export const getResultSubmitSuccess = (ResultSubmit) => {
  return {
    type: GET_RESULT_SUBMIT_SUCCESS,
    payload: ResultSubmit,
  };
};

export const getResultSubmitFail = (error) => {
  return {
    type: GET_RESULT_SUBMIT_FAIL,
    payload: error,
  };
};

///////////////////////
export const getReport = (roundId, labId) => ({
  type: GET_REPORT,
  payload: { roundId, labId },
});

export const getReportSuccess = (Report) => {
  // console.log("Dispatching GET_REPORT_SUCCESS with data:", Report);
  return {
    type: GET_REPORT_SUCCESS,
    payload: Report,
  };
};

export const getReportFail = (error) => {
  return {
    type: GET_REPORT_FAIL,
    payload: error,
  };
};
///////////////////////
export const getSereologyResult = (id) => ({
  type: GET_SERELOGY_RESULT,
  payload: id,
});

export const getSereologyResultSuccess = (Result) => {
  return {
    type: GET_SERELOGY_RESULT_SUCCESS,
    payload: Result,
  };
};

export const getSereologyResultFail = (error) => {
  return {
    type: GET_SERELOGY_RESULT_FAIL,
    payload: error,
  };
};

 export const getMicroReport = id => {
  console.log("📤 Dispatching GET_MICRO_REPORT with ID:", id);
  return {
    type: GET_MICRO_REPORT,
    payload: id,
  };
};

export const getReportMicroSuccess = Report => {
  console.log("✅ Dispatching GET_REPORT_MICRO_SUCCESS with data:", Report);
  return {
    type: GET_REPORT_MICRO_SUCCESS,
    payload: Report,
  };
};

  
  export const getReportMicroFail = (error) => {
    return {
      type: GET_REPORT_MICRO_FAIL,
      payload: error,
    };
  };

export const getQualitativeSummary = id => {
  return {
    type: GET_QUALITATIVE_SUMMARY,
    payload: id,
  };
};

export const getQualitativeSummarySuccess = qualitativeSummary => {
  return {
    type: GET_QUALITATIVE_SUMMARY_SUCCESS,
    payload: qualitativeSummary,
  };
};

export const getQualitativeSummaryFail = error => {
  return {
    type: GET_QUALITATIVE_SUMMARY_FAIL,
    payload: error,
  };
};

